var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.755 14.2559H14.965L14.685 13.9859C15.665 12.8459 16.255 11.3659 16.255 9.75586C16.255 6.16586 13.345 3.25586 9.755 3.25586C6.165 3.25586 3.255 6.16586 3.255 9.75586C3.255 13.3459 6.165 16.2559 9.755 16.2559C11.365 16.2559 12.845 15.6659 13.985 14.6859L14.255 14.9659V15.7559L19.255 20.7459L20.745 19.2559L15.755 14.2559ZM9.755 14.2559C7.26501 14.2559 5.255 12.2459 5.255 9.75586C5.255 7.26586 7.26501 5.25586 9.755 5.25586C12.245 5.25586 14.255 7.26586 14.255 9.75586C14.255 12.2459 12.245 14.2559 9.755 14.2559Z",
    fill: "#0A2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search_black.f7ba6c60fd6460515a31d863499ca8c7.svg";
export { ForwardRef as ReactComponent };